export enum BackendInstances {
  TEST_STAGING = 'https://test-staging',
  STAGING = 'https://tablesready-staging.herokuapp.com',
  DOCKMAGIC_PROD = 'https://dockmagic-production.herokuapp.com',
  TABLESREADY_PROD = 'https://tablesready-production.herokuapp.com'
}

export enum FirebaseInstances {
  TABLESREADY_PROD = 'tablesready-3a36e.web.app',
  DOCKMAGIC_PROD = 'tablesready-3a36e.firebaseapp.com',
  APP_DOCKMAGIC = 'app.dockmagic.com',
  HOST_TABLESREADY = 'host.tablesready.com',
  APP_TABLESREADY = 'app.tablesready.com',

  STAGING = 'staging-4d85l',
  STAGING_TABLESREADY = 'staging.tablesready.com',
  CAPACITOR = 'capacitor',
}
